import React, { useContext } from 'react'

import { PipeySearchContext } from '@providers/PipeyProvider.js';
import Tippy from '@tippyjs/react';

export default function Explination({ tip }) {

	//hårt beroende mot fastig-gui då ett komponentbibliotek var alldeles för ambitiöst från börjant fq-jj
	const { setSearch } = useContext(PipeySearchContext)
	return (
		<span class='component_Explination' style={{ cursor: 'pointer' }} onClick={e => {
			e.stopPropagation()
			setSearch(tip)
		}}>
			<Tippy content={tip + ' - Klicka här för att se mer information'}>
				<i class='far fa-question-circle text-muted'></i>
			</Tippy>
		</span>
	)
}
